import { render, staticRenderFns } from "./NotasCredito.vue?vue&type=template&id=612f1dc3&scoped=true"
import script from "./NotasCredito.vue?vue&type=script&lang=js"
export * from "./NotasCredito.vue?vue&type=script&lang=js"
import style0 from "./NotasCredito.vue?vue&type=style&index=0&id=612f1dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f1dc3",
  null
  
)

export default component.exports